export default "__VITE_ASSET__CUe4C3cS__"